import { Component } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { MyOrdersFiltersBaseComponent } from '../my-orders-filters-base.component';
import { MyOrdersFiltersOptionsMobileComponent } from './my-orders-filters-options-mobile/my-orders-filters-options-mobile.component';
import { DatePipe } from '@angular/common';
import { MyOrdersAnalyticsService } from '@app/my-orders/tracking/analytics/my-orders-analytics.service';

@Component({
  selector: 'app-my-orders-filters-mobile',
  templateUrl: './my-orders-filters-mobile.component.html',
  styleUrls: ['./my-orders-filters-mobile.component.scss'],
})
export class MyOrdersFiltersMobileComponent extends MyOrdersFiltersBaseComponent {
  quickDate: boolean;
  constructor(
    private nav: IonNav,
    modalController: ModalController,
    translateService: TranslateService,
    platformService: PlatformService,
    datePipe: DatePipe,
    myOrdersAnalyticsService: MyOrdersAnalyticsService,
  ) {
    super(
      modalController,
      translateService,
      platformService,
      datePipe,
      myOrdersAnalyticsService,
    );
  }

  ionViewWillEnter(): void {
    if (this.quickDate) {
      this.setSelectedFilter('deliveryDate');
      this.nav.push(MyOrdersFiltersOptionsMobileComponent, {
        selectedFilter: 'deliveryDate',
        filters: this.filters,
        filtersFormGroup: this.filtersFormGroup,
        numberOfItemsSelected: this.selectedFiltersSummary['deliveryDate'],
        isOptionsComponent: true,
        sellerFilterState: this.sellerFilterState,
      });
      this.quickDate = false;
    }
  }

  onFilterSelected(key: string) {
    this.selectedFilter = key;
    this.clearCustomerSearch();

    this.nav.push(MyOrdersFiltersOptionsMobileComponent, {
      selectedFilter: key,
      filters: this.filters,
      filtersFormGroup: this.filtersFormGroup,
      numberOfItemsSelected: this.selectedFiltersSummary[key],
      isOptionsComponent: true,
      sellerFilterState: this.sellerFilterState,
    });
  }
}
